import { render } from "./requests-modal.vue?vue&type=template&id=01b1e4e7&scoped=true"
import script from "./requests-modal.vue?vue&type=script&lang=js"
export * from "./requests-modal.vue?vue&type=script&lang=js"

import "./requests-modal.vue?vue&type=style&index=0&id=01b1e4e7&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b1e4e7"]])

export default __exports__